function getServerURL() {
  const localhost = 'http://localhost:3978'
  const staging = 'https://gohanstg.cloudxier.com'
  const production = 'https://gohan.esgtaskforcekadin.id'
  
  const stagingHost = 'kadin.cloudxier.com'
  const productionHost = 'esgtaskforcekadin.id'

  let host = window.location.host;
  if (host) {
    host = host.toLowerCase();
  }

  let env
  switch (host) {
    case stagingHost:
      env = staging
      break;
    case productionHost:
      env = production
      break;
    default:
      env = localhost
  }
  return env
};

export default getServerURL
